var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('currency-field',{attrs:{"field":_vm.field,"value":_vm.value},on:{"input":_vm.updateValueData}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":_vm.name},domProps:{"value":_vm.valueData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }